// src/pages/Platform/PlatformLogin.js
//
// Login.js's own Super Admin panel equivalent — deliberately much simpler:
// no i18n (the Platform panel isn't translated, at least not yet — none of
// this feature's own plan doc's Phase 6 items ask for that), no tenant
// system-name/theme-color fetch (there is no tenant at this point — see
// PlatformLogin.css's own doc comment), no LanguagePicker. Authenticates
// against PlatformUser (repositories.ControlDB) via POST /platform-api/login
// (handlers.PlatformLoginHandler), never against any tenant's own Users
// table.
import { useState, useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { platformLogin as apiPlatformLogin } from "../../services/api";
import { PlatformAuthContext } from "../../context/PlatformAuthContext";
import "./PlatformLogin.css";

export default function PlatformLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const emailRef = useRef(null);
  const navigate = useNavigate();

  const { login, redirectAfterLogin, setRedirectAfterLogin } = useContext(PlatformAuthContext);

  useEffect(() => {
    if (emailRef.current) emailRef.current.focus();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError("Please enter your email and password");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await apiPlatformLogin(email, password);
      login(res.token, res.user);

      setTimeout(() => {
        const redirectTo = redirectAfterLogin || "/platform/companies";
        setRedirectAfterLogin(null);
        navigate(redirectTo, { replace: true });
      }, 200);
    } catch (err) {
      setError(err.message || "Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="platform-login-container">
      <div className="platform-login-card">
        <span className="platform-login-badge">Super Admin</span>
        <h2 className="platform-login-title">Posflect Platform</h2>
        <p className="platform-login-subtitle">Sign in to manage companies and subscriptions</p>

        <form onSubmit={handleSubmit} className="platform-login-form">
          <div className="form-group">
            <input
              ref={emailRef}
              type="email"
              autoComplete="username"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="platform-login-input"
            />
          </div>

          <div className="form-group">
            <input
              type="password"
              autoComplete="current-password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="platform-login-input"
            />
          </div>

          {error && <div className="platform-login-error">{error}</div>}

          <button type="submit" className="platform-login-submit" disabled={loading}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <p className="platform-login-footer">
          &copy; {new Date().getFullYear()} Posflect &mdash; Platform Administration
        </p>
      </div>
    </div>
  );
}
